/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React from 'react';
import { Form } from 'react-bootstrap';
import Selector from 'components/custom/forms/Selector';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import InformationTooltip from '../ui/InformationTooltip';
import { generateOptions } from 'services/utils';

const LabelSelector = ({
  placeholder,
  required,
  size = 'md',
  label,
  options = {
    data: [],
    valueKey: '',
    labelKey: '',
    descKey: '',
    formatter: null
  },
  labelClass,
  labelProps,
  inputProps,
  errorProps,
  controlId,
  onChange = null,
  newBtnText,
  formik,
  information,
  footerBtnFunc = null,
  controlLabelId,
  callbackOnChange,
  ...props
}) => {
  const handleOnChange = (val, option) => {
    if (onChange) {
      onChange(controlId, val);
      if (controlLabelId) {
        formik.setFieldValue(controlLabelId, option.label);
      }
    } else {
      formik.setFieldValue(controlId, val);
      if (controlLabelId) {
        formik.setFieldValue(controlLabelId, option.label);
      }
    }

    if (callbackOnChange) {
      callbackOnChange(option);
    }
  };
  return (
    <Form.Group className="position-relative" controlId={controlId}>
      <Form.Label
        className={classNames(
          'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium',
          { 'fw-bold': required },
          { 'pe-none': inputProps?.readOnly },
          { 'd-flex flex-between-center': information },
          labelClass
        )}
        {...labelProps}
      >
        <span>
          {label}
          {required ? '*' : ''}
        </span>

        {information && (
          <InformationTooltip
            iconProp={{ className: 'fw-bold' }}
            label={information}
          />
        )}
      </Form.Label>

      <Selector
        placeholder={placeholder}
        dataSet={generateOptions(options)}
        defaultSelect={formik.values[controlId]}
        onChange={handleOnChange}
        size={size}
        inputProps={{
          isInvalid: formik.touched[controlId] && formik.errors[controlId],
          ...inputProps
        }}
        formikError={
          <Form.Control.Feedback tooltip type="invalid" {...errorProps}>
            {formik.errors[controlId]}
          </Form.Control.Feedback>
        }
        footerTextBtn={
          footerBtnFunc
            ? footerBtnFunc
            : search => (
                <Button
                  className="text-decoration-none px-3 w-100 text-start"
                  onClick={() => {}}
                  variant="link"
                >
                  <Icon
                    icon={'flowbite:circle-plus-solid'}
                    className="me-1"
                    fontSize={'16px'}
                  />
                  Add {search ? `"${search}"` : newBtnText}
                </Button>
              )
        }
        {...props}
      />
    </Form.Group>
  );
};

export default LabelSelector;
